import { Inbox, LoaderCircle, RefreshCw } from "lucide-react";
import { Button } from "./Button";

export function LoadingState({ label = "Carregando…" }: { label?: string }) {
  return (
    <div className="data-state" role="status">
      <LoaderCircle className="spin" />
      <p>{label}</p>
    </div>
  );
}

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="data-state">
      <Inbox />
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
  );
}

export function ErrorState({ retry }: { retry?: () => void }) {
  return (
    <div className="data-state data-state--error" role="alert">
      <strong>Não foi possível carregar os dados.</strong>
      <p>Confira sua conexão e tente novamente.</p>
      {retry && (
        <Button variant="secondary" onClick={retry}>
          <RefreshCw size={16} /> Tentar novamente
        </Button>
      )}
    </div>
  );
}
